import { mapGetters } from "vuex";
import { VIcon, VBtn, VCheckbox, VSelect } from "vuetify/lib";
import VPage from "@/vuetify_custom/v-pagination";
import Header from "./components/header";
import { throttle } from "@/libs/functions_utils";
import VTable from "@/vuetify_custom/v-table/v3";
import Attachments from "@/views/components/file/attachments.vue";
import ViewerItem from "@/views/components/viewer/item_v1.vue";
import EditModal from "./components/editModal.jsx";
import Effect from "./components/Effect.jsx";
import { formattingNumber } from "@/libs/util.js";
import ExpandDetail from "./components/ExpandDetail.jsx";
import { F_BLOGGER_RECORDS } from "@/views/business/constants.js";
import { F_BLOGGER_OUT_RECORDS } from "@/views/outsource/libs/constant.js";
import {
  FK_BLOG_XX,
  ZD_BLOG_XX,
} from "@/views/mine/components/fk_modal/constants.js";
import PageContain from "@/views/components/PageContain.vue";
import TableFieldInput from "@/views/blogger/records/components/EditTableField.jsx";
import Tooltip from "@/views/mine/components/fk_modal/Tooltip.vue";
import TooltipBZ from "@/views/blogger/records/components/TooltipBZ.vue";
import EditFansAmount from "@/views/blogger/records/components/EditFansAmount.jsx";
import ArrowComponent from "@/views/blogger/records/components/ArrowComponent";
import DModal from "./components/DModal.vue";
import DelModal from "./components/DelModal";
import {
  getplacingAdsRecordQueryApi,
  placing_ads_record_import,
  postPlacingAdsRecordCloseApi,
  postPlacingAdsRecordSaveApi,
  updateRecordGrade,
} from "./service";
import { put_in_types, publish_form_list } from "../fields";
import Item from "./components/Item.jsx";
import AdditionServiceModal from "./components/AdditionServiceModal.jsx";
import SelectContractTypeModal from "./components/SelectContractTypeModal";
import { http } from "@/libs/util.js";
import { delay_levels_hash } from "@/views/blogger/records/fields.js";
import styles from "./style.module.less";
import RecordRankModal from "./components/RecordRankModal.jsx";

const put_in_types_hash = put_in_types.reduce((t, i) => {
  t[i.value] = i;
  return t;
}, {});
const publish_form_list_hash = publish_form_list.reduce((t, i) => {
  t[i.value] = i.label;
  return t;
}, {});
const effect_keys = [
  "id",
  "delayed",
  "attitude_rating",
  "content_rating",
  "other_evaluation",
  "first_week_effect",
  "amount_effect",
];
export default {
  props: {
    isFin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      params: {
        per_page: 20,
        page: 1,
        total_count: 0,
        sort_key: null,
        sort_type: null,
      },
      list: [],
      loading: false,
      show_pl_modal: false,
      pl: {
        ads_record_ids: [],
        ads_vas_record_ids: [],
      },
      detail_hash: {},
      render_index: 1,
    };
  },
  computed: {
    ...mapGetters({
      teams_hash: "async/root_teams_hash",
    }),
    selectedAll: {
      get() {
        const ids = this.pl.ads_record_ids.map((i) => i.id);
        let res = true;
        this.list.forEach((item) => {
          if (!ids.includes(item.id)) {
            res = false;
          }
        });
        return res;
      },
      set(v) {
        if (v) {
          const ids = this.pl.ads_record_ids.map((i) => i.id);
          this.list.forEach((item) => {
            if (!ids.includes(item.id)) {
              this.pl.ads_record_ids.push(item);
            }
          });
        } else {
          const ids = this.list.map((i) => i.id);
          const arr = [];
          this.pl.ads_record_ids.forEach((item) => {
            if (!ids.includes(item.id)) {
              arr.push(item);
            }
          });
          this.pl.ads_record_ids = arr;
        }
      },
    },
    cur_customer() {
      return this.$store.state.cur_customer || {};
    },
    is_uda() {
      return (
        this.cur_customer.groups &&
        this.cur_customer.groups.includes("UDA_USER_GROUP")
      );
    },
    is_manager() {
      return (
        this.cur_customer.groups &&
        this.cur_customer.groups.includes("PUT_MANAGER_GROUP")
      );
    },
    placing_ads_record_ids_arr() {
      const arr = (this.pl && this.pl.ads_record_ids) || [];
      return arr.map((i) => i.id);
    },
    placing_ads_vas_record_ids_arr() {
      const arr = (this.pl && this.pl.ads_vas_record_ids) || [];
      return arr.map((i) => i.id);
    },
    kolFields() {
      return [
        {
          text: "博主sub_id",
          align: "center",
          value: "boz",
          width: 120,
          render: ({ value: t }) => <div>{(t.kol && t.kol.uid) || "-"}</div>,
        },
        {
          text: "合同编号",
          align: "center",
          value: "placing_ads_contract",
          width: 120,
          render: ({ value: t }) => {
            if (
              !t.placing_ads_contract ||
              !t.placing_ads_contract.contract_id
            ) {
              return "-";
            }
            return (
              <div>
                <ViewerItem
                  type={t.placing_ads_contract.contract_type}
                  modelId={t.placing_ads_contract.contract_id || 0}
                >
                  {" "}
                  <a>{t.placing_ads_contract.contract_uid}</a>{" "}
                </ViewerItem>
              </div>
            );
          },
        },
        {
          text: "收款账号",
          align: "center",
          value: "payee_account",
        },
        {
          text: "平台账号",
          align: "center",
          value: "boz",
          width: 120,
          render: ({ value: t }) => (
            <div>{(t.kol && t.kol.platform_account) || "-"}</div>
          ),
        },
        {
          text: "投放类型",
          align: "center",
          value: "placing_type",
          width: 120,

          render: ({ value: t }) => {
            // put_in_types
            // put_in_types_hash
            return (
              <div>
                {(put_in_types_hash[t.placing_type] &&
                  put_in_types_hash[t.placing_type].label) ||
                  "-"}
              </div>
            );
          },
        },
        {
          text: "收款人姓名",
          align: "center",
          value: "payee_name",
          width: 120,
        },
        {
          text: "合作类型",
          align: "center",
          value: "cooperation_type",
          width: 120,
        },
        {
          text: "发布形式",
          align: "center",
          value: "publish_form",
          width: 120,
          render: ({ value }) => {
            return (
              <div>{publish_form_list_hash[value.publish_form] || "-"}</div>
            );
          },
        },
        {
          text: "团队",
          align: "center",
          value: "team_id",
          width: 120,
          render: ({ value }) => {
            const teams_hash = this.teams_hash || {};
            const team_name =
              teams_hash[value.team_id] && teams_hash[value.team_id].name;
            return <div>{team_name}</div>;
          },
        },
        {
          text: "内容类别",
          align: "center",
          value: "boz",
          width: 120,
          render: ({ value: t }) => <div>{t.tags || "-"}</div>,
        },
        {
          text: "人群画像",
          align: "center",
          value: "persona",
          width: 120,
          render: ({ value: t }) => <div>{t.persona || "-"}</div>,
        },
        {
          text: "发布情况",
          align: "center",
          value: "publish_situations",
          width: 120,
          render: ({ value: t }) => <div>{t.publish_situations || "-"}</div>,
        },
        // {
        //     text: '创建人',
        //     align: 'center',
        //     value: 'docking_customer_name',
        //     width: 120,
        //    // render:(_, t) => <div>{t.sku && t.sku.full_name || '-'}</div>
        // },
      ];
    },
    extendFields() {
      this.render_index;
      const arr = [
        {
          text: "付款单",

          align: "center",
          value: "expense_groups_fk",
          width: 120,
          render: ({ value }) => {
            value = this.detail_hash[value.id] || value;
            return (
              <div>
                {value.expense_groups_fk && value.expense_groups_fk.length
                  ? value.expense_groups_fk.map((item) => (
                      <div style="margin-bottom:0px">
                        <ViewerItem type="ExpenseGroup" modelId={item.id || 0}>
                          {" "}
                          <a>{item.uid}</a>{" "}
                        </ViewerItem>
                      </div>
                    ))
                  : "-"}
              </div>
            );
          },
        },
        {
          text: "账单",

          align: "center",
          value: "expense_groups_zd",
          width: 120,
          render: ({ value }) => {
            value = this.detail_hash[value.id] || value;
            return (
              <div>
                {value.expense_groups_zd && value.expense_groups_zd.length
                  ? value.expense_groups_zd.map((item) => (
                      <div style="margin-bottom:0px">
                        <ViewerItem type="ExpenseGroup" modelId={item.id || 0}>
                          {" "}
                          <a>{item.uid}</a>{" "}
                        </ViewerItem>
                      </div>
                    ))
                  : "-"}
              </div>
            );
          },
        },
        {
          text: "入账时间",
          align: "center",
          value: "accounting_at",
          width: 120,
          show: this.isFin,
        },
        {
          text: "增值服务",
          type: "money_field",
          align: "center",
          value: "vas_amount",
          width: 120,
        },
        {
          text: "追加付款",
          type: "money_field",
          align: "center",
          value: "addition_amount",
          width: 120,
        },
        {
          text: "返点金额",
          type: "money_field",
          align: "center",
          value: "rebate_amount",
          width: 120,
        },

        {
          text: "备注",
          align: "center",
          value: "remark",
          span: 12,
          renderT: ({ value: t }) => {
            return (
              <div style="display:flex">
                <div>备注：</div>
                <div style="flex:1">{t.remark}</div>
              </div>
            );
          },
        },
        {
          text: "投放结果",
          align: "center",
          value: "amount_effect",
          span: 12,
          renderT: ({ value: t }) => {
            return (
              <div style="display:flex">
                <div>投放效果：</div>
                <div style="flex:1">
                  <Effect value={t} isFlex showList={[1, 2, 3]} />
                </div>
              </div>
            );
          },
        },

        {
          text: "附件",
          align: "center",
          value: "bfiles",
          span: 12,
          render: ({ value: t }) => {
            console.log("t", t);
            if (!t.bfiles || !t.bfiles.length) {
              return "-";
            }
            return (
              <div>
                <Attachments files={t.bfiles} showDetail={false} />
              </div>
            );
          },
        },
      ];
      return arr.filter((i) => {
        if (i.show === undefined) {
          return true;
        }
        return i.show;
      });
    },
    table_fields_source() {
      return [
        {
          expand: true,
          z_index: 2,
        },
        {
          text: "投放编号",
          align: "center",
          value: "uid",
          width: 150,
          z_index: 2,
          fixed: "left",
          render: (v, target) => {
            // del
            return (
              <div>
                {v}
                {!!target.init_data && (
                  <span class="color-success" style="font-size:12px">
                    [初始化]
                  </span>
                )}
                {!!target.closed && <p class="color-success">[已完成]</p>}
                {!!target.del && <p class="color-error">[已废弃]</p>}
              </div>
            );
          },
        },
        /* {
                    text: '博主',
                    align: 'center',
                    value: 'boz',
                    width: 120,
                    render:(_, t) => <div>{t.kol && t.kol.uid || '-'}</div>
                }, */
        /* {
                    text: '内容类别',
                    align: 'center',
                    value: 'boz',
                    width: 120,
                    render:(_, t) => <div>{t.kol && t.kol.tags || '-'}</div>
                },*/
        /*  
                 {
                    text: '平台号',
                    align: 'center',
                    value: 'boz',
                    width: 120,
                    render:(_, t) => <div>{t.kol && t.kol.platform_account || '-'}</div>
                },*/

        {
          text: "平台昵称",
          align: "center",
          value: "bozz",
          width: 344,
          z_index: 2,
          fixed: "left",
          render: (_, t) => {
            const value = t.kol || {};
            return (
              <div style="display:flex;">
                <div style="flex:1" />
                <TooltipBZ
                  top
                  render={() => {
                    return (
                      <div>
                        <p class={styles["tsc"]}>
                          <span>博主昵称</span>：
                          <span>{value.platform_nickname}</span>
                        </p>
                        <p class={styles["tsc"]}>
                          <span>博主平台号</span>：
                          <span>{value.platform_account}</span>
                        </p>
                        <p class={styles["tsc"]}>
                          <span>博主粉丝量</span>：
                          <span>{value.fans_amount}</span>
                        </p>
                      </div>
                    );
                  }}
                >
                  <div style="width:300px;white-space: break-spaces;word-break: break-all;">
                    {(t.kol && t.kol.platform_nickname) || "-"}
                  </div>
                </TooltipBZ>
                {!!this.samePerson(t) && (
                  <VIcon
                    x-small
                    style="cursor: pointer;"
                    on={{
                      click: () => {
                        this.$refs.kol.edit(t.kol);
                      },
                    }}
                  >
                    mdi-square-edit-outline
                  </VIcon>
                )}
                <div style="flex:1" />
              </div>
            );
          },
        },
        {
          text: "创建人",
          align: "center",
          value: "docking_customer_name",
          width: 90,
          fixed: "left",
          z_index: 2,
        },
        {
          text: "平台",
          align: "center",
          value: "boz",
          width: 90,
          render: (_, t) => <div>{(t.kol && t.kol.platform) || "-"}</div>,
        },

        {
          text: "SKU",
          align: "center",
          value: "sku",
          width: 120,
          render: (_, t) => <div>{(t.sku && t.sku.full_name) || "-"}</div>,
        },
        {
          text: "预计发布时间",
          align: "center",
          value: "estimate_publish_at",
          width: 140,
          render: (_, t) => (
            <div>
              <span style="position: relative">
                {t.estimate_publish_at}
                <span style="position:absolute">{this.showDelay(t)}</span>
              </span>
            </div>
          ),
        },
        {
          text: "发布时间",
          align: "center",
          value: "publish_at",
          width: 120,
          render: (v, target) => (
            <TableFieldInput
              type="date"
              value={v}
              target={target}
              canEdit={this.showDT(target) || this.sameGroup()}
              on={{
                submit: (params) => this.eidtUnitField(params, "publish_at"),
              }}
            />
          ),
        },
        /*{
                    text: '预计投放时间',
                    align: 'center',
                    value: 'estimate_publish_at',
                    width: 120,
                },
                {
                    text: '投放类型',
                    align: 'center',
                    value: 'placing_type',
                    width: 120,
                    type: 'list_field',
                    item_key: 'value',
                    item_text: 'label',
                    items: put_in_types
                },*/
        {
          text: "预计投放金额",
          //  align: 'center',
          value: "total_price",
          type: "money_field",
          width: 110,
          render: (total_price, t) => {
            const remark = t.remark;

            total_price = formattingNumber(total_price, 2);

            if (!remark) {
              return total_price;
            }
            return (
              <div style="display:flex;">
                <div style="flex:1" />
                <TooltipBZ
                  top
                  render={() => {
                    return (
                      <div>
                        <h4>备注：</h4>
                        <p class={styles["tsc"]} style="max-width:200px">
                          {remark}
                        </p>
                      </div>
                    );
                  }}
                >
                  {total_price || "-"}
                </TooltipBZ>
              </div>
            );
          },
        },
        {
          text: "付款进度",
          type: "money_field",
          //  align: 'center',
          value: "paid_price",
          width: 120,
        },
        {
          text: "消耗进度",
          type: "money_field",
          // align: 'center',
          value: "consume_price",
          width: 120,
        },

        /*
                
                {
                    text: '追加付款',
                    type: 'money_field',
                    align: 'center',
                    value: 'addition_amount',
                    width: 120,
                },*/
        {
          text: "实际消耗",
          type: "money_field",
          // align: 'center',
          value: "payable_price",
          width: 120,
          render: (v, target) => (
            <TableFieldInput
              type="number"
              value={v}
              target={target}
              canEdit={this.showDT(target) || this.sameGroup()}
              valueDis={(val) => formattingNumber(val, 2)}
              on={{
                submit: (params) => this.eidtUnitField(params, "payable_price"),
              }}
            />
          ),
        },
        {
          text: "累计金额",
          type: "money_field",
          //  align: 'center',
          value: "leiji",
          width: 120,
          render: (_, target) => {
            const res = math.eval(
              `${target.vas_amount || 0}+${target.payable_price || 0}+${
                target.addition_amount || 0
              }-${target.rebate_amount || 0}`
            );
            return formattingNumber(res.toNumber(), 2);
          },
        },
        {
          text: "投放链接",
          width: 100,
          value: "placing_ads_url",
          render: (value, params) => {
            if (!value) {
              return <span>-</span>;
            }
            return (
              <div>
                <a href={value} target="__blank">
                  原文
                </a>{" "}
                {!!(this.showDT(params) || this.sameGroup()) && (
                  <VIcon
                    x-small
                    style="cursor: pointer;"
                    on={{
                      click: () => {
                        this.$refs.editModal.edit(params, {
                          fieldsFilter: (arr) =>
                            arr.filter((i) => i.key === "placing_ads_url"),
                          paramsFilter: ({ id, placing_ads_url }) => {
                            return {
                              id,
                              placing_ads_url,
                            };
                          },
                        });
                      },
                    }}
                  >
                    mdi-square-edit-outline
                  </VIcon>
                )}
              </div>
            );
          },
        },
        {
          text: "投放效果",
          align: "center",
          value: "placing_ads_url",
          width: 100,
          render: (_, t) => {
            return (
              <div style="display:flex">
                <Tooltip value={t} showList={[1, 2, 3]} />
                {!!(this.showDT(t) || this.sameGroup()) && (
                  <VIcon
                    x-small
                    style="cursor: pointer;"
                    on={{
                      click: () => {
                        this.$refs.editModal.edit(t, {
                          fieldsFilter: (arr) =>
                            arr.filter((i) => {
                              return effect_keys.includes(i.key);
                            }),
                          paramsFilter: (params) => {
                            const target = {};

                            Object.keys(params).forEach((key) => {
                              if (effect_keys.includes(key)) {
                                target[key] = params[key];
                              }
                            });
                            return target;
                          },
                        });
                      },
                    }}
                  >
                    mdi-square-edit-outline
                  </VIcon>
                )}
              </div>
            );
          },
        },
        /*
               
                {
                    text: '附件',
                    align: 'center',
                    value: 'bfiles',
                    width: 120,
                    render:(_, t) => {
                        if (!t.bfiles || !t.bfiles.length) {
                            return '-'
                        }
                        return <div>
                        <Attachments files={t.bfiles} showDetail={false}/>
                    </div>
                    } 
                },
             
                {
                    text: '投放结果',
                    align: 'center',
                    value: 'amount_effect',
                    width: 400,
                  //  fixed: 'right',
                    z_index:2,
                    render:(_, t) => {
                    
                        return <Effect value={t} showList={[1, 2, 3]}/>
                    }
                },
                */
        /*
                    director_id: 113
                    docking_customer_id: 5821
               */
        {
          text: "评价",
          align: "center",
          value: "put_grade",
          fixed: "right",
          width: 80,
          z_index: 2,
          show: this.is_manager,
          render: (value, target) => {
            const options = [
              {
                key: "优",
                val: 4,
              },
              {
                key: "良",
                val: 3,
              },
              {
                key: "中",
                val: 2,
              },
              {
                key: "差",
                val: 1,
              },
              {
                key: "无",
                val: 0,
              },
            ];
            return (
              <div>
                {/* {JSON.stringify(t)} */}
                <VSelect
                  v-model={target.put_grade}
                  items={options}
                  item-text="key"
                  item-value="val"
                  default
                  label=""
                  size="small"
                  onChange={(e) => {
                    updateRecordGrade({
                      id: target.id,
                      put_grade: e,
                    });
                  }}
                ></VSelect>
              </div>
            );
          },
        },
        {
          text: "操作",
          align: "center",
          value: "action",
          fixed: "right",
          width: 120,
          type: "button_s_field",
          b_text: "操作",
          getButtons: ({ buttons, target }) => {
            return (
              buttons &&
              buttons.filter((item) => {
                if (!item.show) {
                  return true;
                }
                return item.show(target);
              })
            );
          },
          z_index: 2,
          callBack: ({ key }, target) => {
            if (key === "fkProxy" || key === "zdProxy") {
              return this[key] && this[key]([target], "ads_record_ids");
            }
            if (key === "applyContractProxy" && target.placing_ads_contract) {
              this.$vModal.warning({
                title: "提示",
                content: "已经关联了合同的投放记录不能再生成合同！",
              });
              return;
            }

            this[key] && this[key](target);
          },
          buttons: [
            {
              text: "编辑",
              key: "editProxy",
              color: "primary",
              small: true,
              show: (target) => this.showDT(target) || this.sameGroup(),
            },
            {
              text: "加成服务",
              key: "additionServiceProxy",
              color: "primary",
              small: true,
              show: (target) => this.showDT(target),
            },
            {
              text: "申请合同",
              key: "applyContractProxy",
              color: "primary",
              small: true,
              show: () => !this.is_uda,
            },
            {
              text: "付款申请",
              key: "fkProxy",
              color: "primary",
              small: true,
              show: () => !this.is_uda,
            },
            {
              text: "生成账单",
              key: "zdProxy",
              color: "primary",
              small: true,
              show: () => !this.is_uda,
            },

            {
              text: "复制",
              key: "fzProxy",
              color: "primary",
              small: true,
              show: () => !this.isFin,
            },
            {
              text: "废弃",
              key: "delete",
              color: "primary",
              small: true,
              show: (target) => this.showDT(target),
            },
            {
              text: "完结",
              key: "finish",
              color: "primary",
              small: true,
              show: (target) => this.showDT(target),
            },
            {
              text: "舆情数据",
              key: "marketProxy",
              color: "primary",
              small: true,
            },
          ],
        },
      ].filter((item) => item.show !== false);
    },
    table_fields_proxy() {
      if (!this.show_pl_modal) {
        return this.table_fields_source;
      }

      return [
        this.table_fields_source[0],
        {
          text: "选择",
          align: "center",
          value: "xuanze",
          width: 70,
        },
        ...this.table_fields_source.slice(1),
      ];
    },
  },
  watch: {
    show_pl_modal(val) {
      if (!val) {
        this.pl = {
          ads_record_ids: [],
          ads_vas_record_ids: [],
        };
      }
    },
  },
  created() {
    this.teams_hash;
    this.getListProxy = throttle.call(this, this.getList, 200);
    this.getListProxy();
  },
  mounted() {},
  methods: {
    showDelay(t) {
      const delay_level = t.delay_level;
      const delay_obj = delay_levels_hash[delay_level];
      if (!delay_obj) {
        return <span />;
      }
      return (
        <p
          class={styles["p-i-s"]}
          style={`background:${delay_obj.background};color: ${delay_obj.color}`}
        >
          {delay_obj.title}
        </p>
      );
    },
    samePerson(t) {
      // 当前操作人 === 该条申请人
      return t.docking_customer_id === this.cur_customer.id;
    },
    eidtUnitField({ target, value, changeLoading, closeEdit }, key) {
      changeLoading();
      postPlacingAdsRecordSaveApi({
        id: target.id,
        [key]: value,
      })
        .then(() => {
          closeEdit();
          this.getListProxy();
          this.$Message.success("数据修改成功！");
        })
        .finally(() => {
          changeLoading();
        });
    },
    sameGroup() {
      const current_hash = this.$store.state.hash_authority || {};
      return current_hash["tfjl_edit"];
    },
    showDT(target) {
      if (
        this.isFin ||
        [target.director_id, target.docking_customer_id].includes(
          this.cur_customer.id
        )
      ) {
        return true;
      }
      return false;
    },
    upload() {
      this.el = document.createElement("input");
      this.el.setAttribute("type", "file");
      this.$refs.contain.appendChild(this.el);
      this.el.click();
      this.el.addEventListener("change", this.uploadFile);
    },
    uploadFile() {
      const file = this.el.files[0];
      const format = ["xlsx", "csv"];
      const arr = (format || []).map((item) => new RegExp(item + "$"));
      if (arr.some((item) => item.test(file.type) || item.test(file.name))) {
        if (file.name.indexOf("%") > -1) {
          this.$Modal.error({
            title: "提示",
            content: "文件名不能包含百分号%",
          });
          return;
        }
        this.$emit("start");
        this.uploading = true;
        const formData = new FormData();
        formData.append("file", file);
        // placing_ads_record_import
        http
          .post_upload(placing_ads_record_import, { formData })
          .then((res) => {
            if (!this.data_arr) {
              this.data_arr = [];
            }
            this.data_arr.push(res.file);
            this.$emit("done", res);
            this.$emit("uploaded", res.file);
            this.params.page = 1;
            this.$nextTick(this.getListProxy);
          })
          .finally(() => {
            this.$emit("finally");
            this.uploading = false;
          });
      } else {
        this.$Modal.error({
          title: "提示",
          content: `请上传${format.join("、")}格式文件`,
        });
      }
      this.el.removeEventListener("change", this.uploadFile);
      const childrenInputs = this.$refs.contain.childNodes;
      for (let i = 0, len = childrenInputs.length; i < len; i++) {
        this.$refs.contain.removeChild(childrenInputs[i]);
      }
      this.el = null;
    },
    ChangePlItem(target, type) {
      if (type === "ads_record_ids") {
        if (!this.placing_ads_record_ids_arr.includes(target.id)) {
          this.pl.ads_record_ids.push(target);
        } else {
          const index = this.placing_ads_record_ids_arr.indexOf(target.id);
          this.pl.ads_record_ids.splice(index, 1);
        }
      } else {
        if (!this.placing_ads_vas_record_ids_arr.includes(target.id)) {
          this.pl.ads_vas_record_ids.push(target);
        } else {
          const index = this.placing_ads_vas_record_ids_arr.indexOf(target.id);
          this.pl.ads_vas_record_ids.splice(index, 1);
        }
      }
    },
    plAdd() {
      this.show_pl_modal = true;
    },
    applyContractProxy(target) {
      this.$refs.selectContractTypeModal.edit(target);
    },
    applyContract(target) {
      let arr = [target];
      if (target instanceof Array) {
        arr = target;
      }

      localStorage.setItem(F_BLOGGER_RECORDS, JSON.stringify(arr));
      window.open("/business/contract");
    },
    applyOutContract(target) {
      let arr = [target];
      if (target instanceof Array) {
        arr = target;
      }

      localStorage.setItem(F_BLOGGER_OUT_RECORDS, JSON.stringify(arr));
      window.open("/outsource/my_contract");
    },
    fzProxy(target) {
      this.$refs.editModal.copy(target);
    },
    zdProxy(target, fk_type) {
      let params = {};
      switch (fk_type) {
        case "ads_record_ids":
          params = {
            ads_record_ids: target,
          };
          break;
        case "ytd":
          params = {
            ytd_ads_record_ids: target,
          };
          break;
        case "ads_vas_record_ids":
          params = {
            ads_vas_record_ids: target,
          };
          break;
        default:
          return;
      }
      for (let i = 0; i < target.length; i++) {
        const t = target[i];
        const go_1 =
          Number(t.consume_price) === Number(t.total_price) &&
          Number(t.consume_price) === 0;
        const go_2 = Number(t.consume_price) < Number(t.total_price);
        if (!(go_1 || go_2)) {
          this.$vModal.warning({
            title: "提示",
            content: "消耗进度需要小于预计投放金额，才可以生成账单！",
          });
          return;
        }
      }
      localStorage.setItem(ZD_BLOG_XX, JSON.stringify(params));
      window.open("/mine/expense_group_bill");
    },
    fkProxy(target, fk_type) {
      let params = {};
      switch (fk_type) {
        case "ads_record_ids":
          params = {
            ads_record_ids: target,
          };
          break;
        case "ads_vas_record_ids":
          params = {
            ads_vas_record_ids: target,
          };
          break;
        default:
          return;
      }
      if (fk_type === "ads_record_ids") {
        for (let i = 0; i < target.length; i++) {
          const t = target[i];
          const go_1 =
            Number(t.paid_price) === Number(t.total_price) &&
            Number(t.paid_price) === 0;
          const go_2 = Number(t.paid_price) < Number(t.total_price);
          if (!(go_1 || go_2)) {
            this.$vModal.warning({
              title: "提示",
              content: "付款进度需要小于预计投放金额，才可以付款！",
            });
            return;
          }
        }
      }
      localStorage.setItem(FK_BLOG_XX, JSON.stringify(params));
      window.open("/mine/expense_group_company");
    },
    additionServiceProxy(p, c) {
      this.$refs.additionServiceModal.edit(p, c);
    },
    editProxy(params) {
      this.$refs.editModal.edit(params);
    },
    marketProxy(params) {
      this.$refs.record_rank.showRank(params.placing_ads_url);
    },
    delete(params) {
      this.$refs.del.edit(params);
    },
    getList(params) {
      if (!params) {
        params =
          this.$refs.header &&
          this.$refs.header.getParams &&
          this.$refs.header.getParams();
      }
      params = { ...params };
      if (params.closed === 0) {
        params.closed = undefined;
      }
      if (params.have_paid === 0) {
        params.have_paid = undefined;
      }
      if (params.have_payable === 0) {
        params.have_payable = undefined;
      }
      const skuIds = params.sku_id ? params.sku_id.join(",") : undefined;
      this.loading = true;
      getplacingAdsRecordQueryApi({
        ...this.params,
        ...(params || {}),
        sku_id: skuIds,
        query_all: this.isFin,
      })
        .then((res) => {
          this.params = {
            ...this.params,
            per_page: res.per_page,
            page: res.cur_page,
            total_count: res.total_count,
          };
          this.list = res.placing_ads_records;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    finish(item) {
      this.$vModal.confirm({
        title: "提示",
        content: `确定完结单据${item.uid}？`,
        loading: true,
        onOk: ({ destroy, stopLoading }) => {
          postPlacingAdsRecordCloseApi({ id: item.id })
            .then((res) => {
              this.$Message.success("数据保存成功！");
            })
            .finally(() => {
              stopLoading();
              destroy();
            });
        },
      });
    },
  },
  render() {
    const _this = this;
    return (
      <div style="postion:relative">
        <div class={styles["z-l"]}>
          <a href="https://shimo.im/docs/gO3oxKaXenfg7vqD" target="__blank">
            《投放费用管理指南》
          </a>
        </div>
        <div>
          <div>
            <Header
              ref="header"
              on={{
                add: this.editProxy,
                search: (params) => {
                  params = params || {};
                  this.getListProxy({ ...params, page: 1 });
                },
                pl: this.plAdd,
                export: this.plAdd,
                import: this.upload,
              }}
            />
          </div>
          <PageContain reserved-height={260}>
            <div class={styles["table"]} style="height:100%">
              <VTable
                fixedHeader
                fixedHeaderZindex={3}
                headers={this.table_fields_proxy}
                desserts={this.list}
                loading={this.loading}
                scopedSlots={{
                  header: ({ props }) => {
                    return (
                      <thead>
                        {" "}
                        <tr style="font-size:12px">
                          {props.headers.map((item) => {
                            if (item.value === "xuanze") {
                              return (
                                <th
                                  style={{
                                    textAlign: item.align,
                                    width: item.width + "px",
                                    "min-width": item.width + "px",
                                  }}
                                  class={item.class}
                                >
                                  <VCheckbox
                                    style="margin-left:5px"
                                    v-model={_this.selectedAll}
                                  />
                                </th>
                              );
                            }
                            if (
                              item.value === "estimate_publish_at" ||
                              item.value === "publish_at"
                            ) {
                              let v = "";
                              if (this.params.sort_key === item.value) {
                                v = this.params.sort_type;
                              }

                              return (
                                <th
                                  style={{
                                    textAlign: item.align,
                                    width: item.width + "px",
                                    "min-width": item.width + "px",
                                  }}
                                  class={item.class}
                                >
                                  <div>
                                    <span>{item.text}</span>
                                    <ArrowComponent
                                      value={v}
                                      on={{
                                        change: (val) => {
                                          switch (val) {
                                            case "asc":
                                            case "desc":
                                              this.params.sort_key = item.value;
                                              this.params.sort_type = val;
                                              break;
                                            default:
                                              this.params.sort_key = "";
                                              this.params.sort_type = "";
                                              break;
                                          }
                                          this.$nextTick(() => {
                                            this.params.page = 1;
                                            this.getListProxy();
                                          });
                                        },
                                      }}
                                    />
                                  </div>
                                </th>
                              );
                            }

                            return (
                              <th
                                style={{
                                  textAlign: item.align,
                                  width: item.width + "px",
                                  "min-width": item.width + "px",
                                  padding: "0px",
                                  //  display: 'block'
                                }}
                                class={item.class}
                              >
                                {item.text}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                    );
                  },
                  expand: ({ item }) => {
                    return (
                      <div style="margin:20px 68px;max-width:1000px">
                        <div style="margin:10px 0 20px;padding:10px 0 0 0">
                          <Item
                            fields={this.kolFields}
                            value={item}
                            title="基础信息"
                          />
                        </div>

                        <hr />
                        <div style="margin:10px 0 20px;padding:10px 0">
                          <Item
                            fields={this.extendFields}
                            value={item}
                            title="投放记录"
                          />
                        </div>
                        <hr />
                        <ExpandDetail
                          ref={`expand-${item.id}`}
                          detail={item}
                          showPl={this.show_pl_modal}
                          adsArr={this.placing_ads_vas_record_ids_arr}
                          showButtonD={this.showDT(item)}
                          on={{
                            edit: (p, c) => this.additionServiceProxy(p, c),
                            ChangePlItem: (...a) => this.ChangePlItem(...a),
                            handle: ({ key, target }) => {
                              this[key]([target], "ads_vas_record_ids");
                            },
                            getData: (data) => {
                              this.render_index++;
                              this.detail_hash[data.id] = data;
                            },
                          }}
                        />
                      </div>
                    );
                  },
                  xuanze: (_, item) => {
                    return (
                      <div>
                        <VBtn
                          fab
                          depressed
                          x-small
                          on={{
                            click: () =>
                              this.ChangePlItem(item, "ads_record_ids"),
                          }}
                        >
                          {this.placing_ads_record_ids_arr.includes(
                            item.id
                          ) && (
                            <VIcon color="primary">mdi-checkbox-marked</VIcon>
                          )}
                          {!this.placing_ads_record_ids_arr.includes(
                            item.id
                          ) && <VIcon>mdi-checkbox-blank-outline</VIcon>}
                        </VBtn>
                      </div>
                    );
                  },
                }}
              />
            </div>
          </PageContain>
        </div>
        <EditModal
          ref="editModal"
          isFin={this.isFin}
          on={{
            success: () => {
              this.params.page = 1;
              this.$nextTick(this.getListProxy);
            },
          }}
        />
        <AdditionServiceModal
          ref="additionServiceModal"
          on={{
            success: (item) => {
              this.$refs[`expand-${item.placing_ads_record_id}`] &&
                this.$refs[`expand-${item.placing_ads_record_id}`].getData();
            },
          }}
        />
        <SelectContractTypeModal
          ref="selectContractTypeModal"
          on={{
            select: (type, target) => {
              // 普通合同
              if (type === "Contract") {
                this.applyContract(target);
                return;
              }
              this.applyOutContract(target);
            },
            cancel: () => {
              this.show_pl_modal = true;
              this.pl = this.$refs.pl.cx();
            },
          }}
        />
        <DelModal
          ref="del"
          on={{
            success: () => {
              this.params.page = 1;
              this.$nextTick(this.getListProxy);
            },
          }}
        ></DelModal>
        <DModal
          ref="pl"
          v-model={this.pl}
          isFin={this.isFin}
          show={this.show_pl_modal}
          on={{
            close: () => {
              this.show_pl_modal = false;
            },
            submit: ({ handle_type, bill_type, target }) => {
              // bill_type 表示 记录 or 加成服务
              switch (handle_type) {
                case "ht": // 生成合同
                  this.applyContractProxy(target.ads_record_ids);
                  break;
                case "fk": // 生成付款单
                  this.fkProxy(this.pl[bill_type], bill_type);
                  break;
                case "ytd":
                case "zd":
                  this.zdProxy(this.pl[bill_type], "ytd");
                  break;
                default:
                  break;
              }
            },
          }}
        />
        <div ref="contain" style="display:none" />
        <EditFansAmount
          ref="kol"
          on={{
            success: () => this.getListProxy,
          }}
        />
        <div class="paginate-fix-bottom" style="z-index:3">
          {!!this.params.total_count && (
            <VPage
              current={this.params.page}
              total={this.params.total_count}
              page-size={this.params.per_page}
              size-arr={[10, 20, 50]}
              on={{
                changePageSize: (per_page) => {
                  this.params.per_page = per_page;
                  this.params.page = 1;
                  this.$nextTick(this.getListProxy);
                },
                pageChange: (page) => {
                  this.params.page = page;
                  this.$nextTick(this.getListProxy);
                },
              }}
            />
          )}
        </div>
        <RecordRankModal
          ref="record_rank"
          dis={this.showRankModal}
          on={{
            close: () => {
              this.$refs.record_rank.dis = false;
            },
          }}
        />
      </div>
    );
  },
};
